import { ColorEnum } from '@enum/style/color.enum';

import { MenuStyleInterface } from './menu-style.interface';

export const MenuDarkTheme: MenuStyleInterface = {
  colorBgContainer: ColorEnum.Black100,
  colorBgActive: ColorEnum.OuterSpace,
  colorText: ColorEnum.MonochromesCloud,
  colorIcon: ColorEnum.Teal100,
  borderRadiusLG: 0,
  borderRadiusSM: 0,
  borderRadiusXS: 0,
};
